// extracted by mini-css-extract-plugin
export default {"title":"ProjectCost_title__g920L","list":"ProjectCost_list__wP9nG","list-item":"ProjectCost_list-item__9XCrZ"};